import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { HygieneInspectionStatus } from '../../../shared/models';

interface InspectionProgressStep {
  status: HygieneInspectionStatus;
  completed: boolean;
  optional: boolean;
}

@Component({
  selector: 'backoffice-inspection-progress-hygiene',
  templateUrl: './inspection-progress-hygiene.component.html',
  styleUrls: ['./inspection-progress-hygiene.component.scss'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class InspectionProgressHygieneComponent implements OnInit {
  @Input() status!: HygieneInspectionStatus;
  steps: InspectionProgressStep[] = [];
  selectedIndex = 0;

  ngOnInit() {
    let matched = false;
    Object.keys(HygieneInspectionStatus).forEach((value, index) => {
      if (value === this.status) {
        matched = true;
        this.selectedIndex = index;
      }
      this.steps.push({
        completed:
          this.status &&
          (!matched ||
            (this.status === HygieneInspectionStatus.COMPLETED && matched)),
        status: value as HygieneInspectionStatus,
        optional: false,
      });
    });
  }
}
